import React from 'react'

const ProfilePreview = () => {
  return (
    <div>ProfilePreview</div>
  )
}

export default ProfilePreview